import api from './api';

/**
 * Fetch paginated zone sessions for HR Admin.
 * @param {Object} params - { employee_code, project_id, date_from, date_to, status, per_page, page }
 */
export const fetchZoneSessions = async (params = {}) => {
  const res = await api.get('/admin/zone-sessions', { params });
  return res.data;
};

/**
 * Fetch summary stats (active now, total sessions, avg duration, by project/employee).
 * @param {Object} params - { date_from, date_to }
 */
export const fetchZoneSessionsSummary = async (params = {}) => {
  const res = await api.get('/admin/zone-sessions/summary', { params });
  return res.data;
};
